<template>
  <div id="outer" >
    <div id="mid">
      <div id="inner" >
        <article id="container" >
          <div class="print-wrp-contents">
            <p class="print-date-issue">発行日：{{ dateOfIssue }}</p>
            <h1 class="print-hdg-lv1">お見積書</h1>
            <p class="print-logo">
              <img src="/lc/app/images/logo-print.png" width="200" height="32" alt="新日本法規出版株式会社">
            </p>
            <p class="print-address">
              〒460-8455<br>
              名古屋市中区栄1-23-20<br>
              TEL (052) 211-5718 FAX (052) 220-1455
            </p>
            <p class="print-name-wrp">
              <span class="print-name">{{ profile.name }}</span> <span class="print-name-keisho">様</span>
            </p>

            <p class="print-item">
              件名
              <span>商品代</span>
            </p>

            <div class="print-price-wrp">
              <p class="print-price01">下記の通りお見積もり申し上げます。</p>
              <p class="print-price02">
                <span class="print-price03">お見積金額</span>
                <span class="print-price04">{{ group1.totalFeeDisp }}</span>
                <span class="print-price05">円（税込）</span>
              </p>
            </div>

            <div class="table01 print-table">
              <table class="outer-table table-estimate-final"
                v-for="(item, index) in group1.productsLicensesDisp" :key="'package_' + index">
                <thead>
                  <tr>
                    <th class="package-header">
                      <span>
                      <span class="package-name">{{ item.package_name }}</span>
                      <span class="package-price">お見積金額 合計 {{ item.sub_total_fee_disp }}円（税込）</span>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <table class="inner-table">
                        <thead>
                          <tr>
                            <th><span class="item-name">商品名</span></th>
                            <th><span class="item-name">ライセンス数</span></th>
                            <th><span class="item-name">ライセンス期間</span></th>
                            <th><span class="item-name">価格<small>(税込)</small></span></th>
                          </tr>
                        </thead>
                        <tbody>

                          <tr v-for="(item2, index2) in item.basic_products" :key="'basic_' + index2">
                            <td>
                              <div class="print-item-info">
                                <span class="print-item-info-01 basic-product">{{ item2.name }}</span>
                              </div>
                            </td>
                            <td>{{ item2.license_number }}</td>
                            <td>
                              <div>12カ月（{{ group1.licensePeriodStart }}～{{ group1.licensePeriodEnd }}）</div>
                            </td>
                            <td>
                              <div>{{ item2.price_disp }} 円</div>
                            </td>
                          </tr>

                          <tr v-for="(item3, index3) in item.option_products" :key="'option_' + index3">
                            <td>
                              <div class="print-item-info">
                                <span class="print-item-info-01 option-product">{{ item3.name }}</span>
                              </div>
                            </td>
                            <td>{{ item3.license_number }}</td>
                            <td>
                              <div>12カ月（{{ group1.licensePeriodStart }}～{{ group1.licensePeriodEnd }}）</div>
                            </td>
                            <td>
                              <div>{{ item3.price_disp }} 円</div>
                            </td>
                          </tr>

                        </tbody>
                      </table>

                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="contents-area-02 box-gray01 print-mitumori-note">
              本見積書は申込書としてはご使用いただけません。<br>
              お申し込み（ご契約）完了月の月末まで無料でご利用いただけますが、翌月より年間料金が発生いたします。<br>
              既にご利用いただいているパッケージのライセンスを追加購入した場合は、既存のライセンス期限に合わせてご購入いただけます（年間料金を月割計算し、利用料金を算出いたします。）。<br>
              本見積書の発行日より月をまたぐ場合は、ライセンス期限や価格に差異が生じる場合がありますので、改めてお見積り、あるいはお問い合わせください。<br>
              お見積りいただく商品点数が多い場合は、本見積書が複数ページにまたがることがありますのでご留意ください。
            </div>
          </div>

          <p class="print-close">
            <button type="button" class="btn-01" onclick="window.close();">閉じる</button>
          </p>
        </article>
      </div>

    </div>
  </div>
</template>
<script>
import { defineComponent, onMounted } from '@vue/composition-api'
import store from '@/store'
import * as logicLoggedinNewApplication from '@/logic/new-application/LoggedinNewApplication'
import * as logicProfile from '@/logic/profile/Profile'

export default defineComponent({
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
      profile.init()
    })
    // 発行日（今日の日付）
    const today = new Date()
    const year = today.getFullYear()
    // JavaScript上の月は0スタートのため、本来の月表示に合わせるために1ヶ月分後ろにずらす必要がある。
    const month = today.getMonth() + 1
    const day = today.getDate()
    const dateOfIssue = year + '年' + month + '月' + day + '日'

    const group1 = logicLoggedinNewApplication.getGroupConfirm(props, context)
    const profile = logicProfile.getGroup(props, context)

    return {
      group1,
      profile,
      dateOfIssue
    }
  }
})

</script>

<style lang="scss">
  * {
    position: relative;
  }
  html {
    overflow-y: visible;
  }
  body {
    background: #fff;
    font-family: "游ゴシック","YuGothic","ヒラギノ角ゴ ProN W3","HiraKakuProN-W3","ヒラギノ角ゴ Pro W3","Hiragino Kaku Gothic Pro","メイリオ",Meiryo,"ＭＳ Ｐゴシック","helvetica","arial",sans-serif;
  }

  /* 
  【注意事項】
  印刷画面は、テーブルに対してbackground-colorを設定すると
  Firefoxなどで罫線が表示されない問題があるため、
  background-colorは一切設定しない。
   */
  .table01 {
    margin: 20px 0 0;
    table {
      width: 100%;
      margin: 0;
      border-collapse: collapse;
      border-spacing: 0;
      border-bottom: 1px solid #e8e8e8;
      border-right: 1px solid #e8e8e8;
      th {
        padding: 0;
        border-top: 1px solid #e8e8e8;
        border-left: 1px solid #e8e8e8;
        line-height: 1.5;
        vertical-align: middle;
        font-weight: normal;
        font-size: 14px;
        & > span {
          display: block;
          padding: 15px 18px 14px 20px;
          height: 100%;
          & > small{
            display: inline;
            font-size: 12px;
            color: #777;
          }
        }
      }
      td {
        padding: 15px 15px 14px 15px;
        border-top: 1px solid #e8e8e8;
        border-left: 1px solid #e8e8e8;
        line-height: 1.5;
        vertical-align: middle;
        font-weight: normal;
        color: #555;
        font-size: 14px;
      }
    }
  }

  #wrapper.print-contents {
    padding: 0;
    background: #fff;
    position: relative;
  }
  .print-wrp-contents{
    width: 640px;
    margin: 0 auto;
  }
  .print-hdg-lv1{
    margin: 0 auto;
    text-align: center !important;
    font-size: 24px;
    color: #2c374b;
    letter-spacing: 0.02em;
  }
  .print-date-issue {
    padding: 5px 0 0;
    text-align: right;
    font-size: 12px;
  }
  .print-logo {
    position: absolute;
    right: 0;
    top: 110px;
  }
  .print-address {
    position: absolute;
    right: 0;
    top: 150px;
    font-size: 11px;
    text-align: right;
  }
  .print-name-wrp {
    padding: 40px 0 0;
    width: 320px;
  }
  .print-name {
    display: inline-block;
    max-width: 300px;
    font-size: 16px;
    border-bottom: 1px solid #ccc;
  }
  .print-name-keisho {
    display: inline-block;
    width: 20px;
    font-size: 16px;
  }
  .print-price-wrp {
    padding: 20px 0 0;
  }
  .print-item {
    padding: 20px 0 0;
    font-size: 16px;
  }
  .print-item span {
    display: inline-block;
    padding: 0 0 0 10px;
  }
  // .print-item-info-01 {
  //   display: block;
  //   &.option-product {
  //     margin-left: 16px;
  //   }
  // }
  .print-price-wrp {
    padding: 20px 0 0;
  }
  .print-price01 {
    font-size: 10px;
  }
  .print-price02 {
    display: inline-block;
    padding: 0;
    border-bottom: 1px solid #ccc;
  }
  .print-price03 {
    display: inline-block;
    font-size: 14px;
    vertical-align: baseline;
  }
  .print-price04 {
    display: inline-block;
    font-size: 20px;
    vertical-align: baseline;
    padding: 0 10px 0 50px;
  }
  .print-price05 {
    display: inline-block;
    font-size: 10px;
    vertical-align: baseline;
  }
  .print-table {
    margin: 40px 0 0;
    .outer-table {
      &:not(:last-child) {
        margin-bottom: 20px;
      }
      th.package-header {
        text-align: left;
        span {
          &.package-name {
            padding: 0 0 6px 0 !important;
            display: block;
            font-size: 16px;
          }
          &.package-price {
            padding: 0 !important;
            display: block;
            font-size: 14px;
          }
        }
      }
    }
    .outer-table {
      &.table-estimate-final,
      &.table-service-purchase {
        .inner-table {
          thead {
            th:nth-of-type(1) {
              width: 30%;
            }
            th:nth-of-type(2) {
              width: 17%;
            }
            th:nth-of-type(3) {
              width: 30%;
            }
            th:nth-of-type(4) {
              width: 23%;
            }
          }
        }
      }
    }
    .inner-table {
      thead {
        th {
          font-size: 11px;
          span {
            padding: 10px 8px;
          }
          small {
            font-size: 10px;
          }
        }
      }
      tbody {
        td:nth-of-type(2) {
          text-align: center;
        }
        td {
          font-size: 11px;
          padding: 10px 8px;
        }
      }
    }
  }
  .print-mitumori-note {
    border: 3px solid #eeeeee;
    margin: 20px 0 0;
    padding: 10px 20px;
    font-size: 11px;
  }
  .print-close {
    margin: 30px 0 30px 0;
    text-align: center;
    .btn-01{
      min-width: 100px;
      text-align: center;
      height: 30px;
      line-height: 30px;
      padding: 0px 10px;
      position: relative;
      font-size: 12px;
      color: #999 !important;
      border-color: #999 !important;
      border-style: solid;
      border-width: 1px;
    }
    .btn-01:after{
      content: "×";
      position: absolute;
      top: 0;
      right: 10px;
      font-size: 16px;
      color: #999	 !important;
    }
  }

  @media print{
    html,
    body ,
    .print-hdg-lv1,
    .print-date-issue ,
    .print-address,
    .print-name,
    .print-name-keisho,
    .print-item span,
    .print-price01,
    .print-price02,
    .print-table.table01 thead th,
    .print-table.table01 thead th small ,
    .print-table td,
    .print-mitumori-note{
      color: #000;
    }
    .table01 {
      table {
        border-bottom: 1px solid #000;
        border-right: 1px solid #000;
        th {
          border-top: 1px solid #000;
          border-left: 1px solid #000;
        }
        td {
          border-top: 1px solid #000;
          border-left: 1px solid #000;
        }
      }
    }
    .outer-table {
      page-break-inside: avoid;
    }
    .print-name {
      border-bottom: 1px solid #000;
    }
    .print-price02 {
      border-bottom: 1px solid #000;
    }
    .print-mitumori-note {
      border: 1px solid #000;
    }
    .print-close {
      display: none;
    }
  }

</style>
